export default __webpack_public_path__ + "static/media/puncture.83ab0109.png";